<template>
  <tr>
    <td>
      <basic-input
        v-model="customerData.name"
        placeholder="Nhập Họ và tên"
        :required="true"
        :value.sync="customerData.name"
        label=""
        v-validate="'required'"
        name="name"
        data-vv-as="Họ và Tên"
      />
    </td>
    <td>
      <basic-input
        v-model="customerData.phoneNumber"
        placeholder="SĐT hoặc Mã bệnh nhân"
        :required="true"
        maxlength="12"
        :value.sync="customerData.phoneNumber"
        name="name"
        data-vv-as="Số điện thoại hoặc Mã bệnh nhân"
      />
    </td>
    <td>
      <basic-select
        placeholder="Giới tính"
        name="gender"
        :options="genderOpts"
        :solid="false"
        :required="true"
        :allowEmpty="false"
        track-by="value"
        value-label="text"
        v-model="customerData.gender"
        :value.sync="customerData.gender"
        changeValueByObject
        data-vv-as="gender"
      />
    </td>
    <td>
      <basic-select
        placeholder="--------"
        name="title"
        :options="titleOpts"
        :solid="false"
        :allowEmpty="true"
        track-by="value"
        value-label="text"
        v-model="customerData.title"
        :value.sync="customerData.title"
        changeValueByObject
        data-vv-as="title"
      />
    </td>
    <td>
      <basic-input
        v-model="customerData.contactSource"
        placeholder="Nguồn"
        :value.sync="customerData.contactSource"
        name="contactSource"
      />
    </td>
    <td>
      <basic-input
        v-model="customerData.dateOfBirth"
        placeholder="1999"
        :value.sync="customerData.dateOfBirth"
        name="dateOfBirth"
      />
    </td>
    <td>
      <basic-select
        placeholder="Loại bệnh"
        name="Disease"
        :options="diseasesOpts"
        :solid="false"
        :required="true"
        :allowEmpty="false"
        track-by="value"
        value-label="text"
        v-model="customerData.diseaseType"
        :value.sync="customerData.diseaseType"
        changeValueByObject
        data-vv-as="Disease"
      />
    </td>
    <!-- <td>
      <basic-select
        placeholder="Chọn khóa"
        name="Course"
        :options="courses"
        :solid="false"
        :required="true"
        :allowEmpty="false"
        track-by="value"
        value-label="text"
        v-model="customerData.course"
        :value.sync="customerData.course"
        changeValueByObject
        data-vv-as="Course"
      />
    </td> -->
    <!-- <td>
      <basic-select
        placeholder="Chọn đối tác"
        name="Partner"
        class="partner"
        :options="partners"
        :solid="false"
        :allowEmpty="false"
        :required="true"
        value-label="value"
        :value.sync="customerData.customerPartnerId"
        v-model="customerData.customerPartnerId"
        @change="clearDates"
        v-validate="'required'"
        changeValueByObject
        data-vv-as="Partner"
      />
    </td> -->
    <td>
      <basic-select
        placeholder="Chọn coach"
        name="Coach"
        :options="listCoaches"
        :solid="false"
        :required="true"
        :allowEmpty="false"
        track-by="value"
        value-label="text"
        v-model="customerData.coach"
        :value.sync="customerData.coach"
        changeValueByObject
        data-vv-as="Coach"
      />
    </td>

    <td>
      <basic-select
        placeholder="Chọn gói dịch vụ"
        track-by="code"
        value-label="name"
        :options="this.packagesName"
        :value.sync="customerData.packageId"
        v-model="customerData.packageId"
        @change="clearDates"
        required
        name="this.data"
        v-validate="'required'"
        changeValueByObject
      />
    </td>

    <td>
      <basic-select
        placeholder="Chọn"
        name="useZaloGroup"
        :options="useZaloGroupOpts"
        :solid="false"
        :allowEmpty="false"
        track-by="value"
        value-label="text"
        v-model="customerData.useZaloGroup"
        :value.sync="customerData.useZaloGroup"
        changeValueByObject
      />
    </td>

    <td style="transform: scale(0.6)">
      <button
        class="btn btn-danger"
        @click.stop="deleteCustomer(customerIndex)"
      >
        <span class="svg-icon m-0">
          <inline-svg src="/media/svg/icons/Neolex/Basic/trash.svg" />
        </span>
      </button>
    </td>
  </tr>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { DISEASES,ONBOARDING } from '../CustomerReceiveEnum';

const { mapState, mapActions } = createNamespacedHelpers('customerReceives');

export default {
  props: ['customerData', 'index', 'customerIndex'],
  data() {
    return {
      listCoaches: [],
      packagesName: [],
      selectedPackage: null,
    };
  },
  computed: {
    ...mapState(['data', 'courses', 'coaches', 'partners']),
    diseasesOpts() {
      return [
        { text: 'Tiền đái tháo đường', value: DISEASES.TIEN_DAI_THAO_DUONG },
        { text: 'Đái tháo đường típ 1', value: DISEASES.DAI_THAO_DUONG_TIP_1 },
        { text: 'Đái tháo đường típ 2', value: DISEASES.DAI_THAO_DUONG_TIP_2 },
        {
          text: 'Đái tháo đường thai kì',
          value: DISEASES.DAI_THAO_DUONG_THAI_KI,
        },
        { text: 'Tăng huyết áp', value: DISEASES.TANG_HUYET_AP },
        { text: 'Béo phì', value: DISEASES.BEO_PHI },
        { text: 'Khác', value: DISEASES.KHAC },
      ];
    },
    genderOpts() {
      return [
        { text: 'Nam', value: '1' },
        { text: 'Nữ', value: '2' },
        { text: 'Khác', value: '0' },
      ];
    },
    titleOpts() {
      return [
        { text: 'Cô', value: '0' },
        { text: 'Chú', value: '1' },
        { text: 'Anh', value: '2' },
        { text: 'Chị', value: '3' },
        { text: 'Em', value: '4' },
      ];
    },
    useZaloGroupOpts() {
      return [
        { text: 'Có', value: true },
        { text: 'Không', value: false },
      ];
    },
  },
  methods: {
    ...mapActions(['updateCustomer', 'deleteCustomer']),
    async choosenCourse() {
      await this.$api
        .get(
          `Courses/CoachInCourse?courseId=${ONBOARDING.ID}`,
        )
        .then(({ data }) => {
          this.listCoaches = data?.map((c) => {
            return {
              text: c?.fullName,
              value: c?.id,
            };
          });
        })
        .catch((error) => {
          this.$toastr.e({
            title: 'Lỗi',
            msg: error,
          });
          return Promise.reject(error);
        });
    },
    async GetPackage() {
      await this.$api
        .get('/Package')
        .then((response) => {
          this.packagesName = response.data;
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    },
  },
  watch: {
    customerData: {
      handler(newVal) {
        this.updateCustomer({ index: this.index, customerData: newVal });
      },
      deep: true,
    },
    'customerData.course': {
      handler(newValue) {
        if (newValue) {
          this.customerData.coach = null;
          this.choosenCourse();
        }
      },
      deep: true,
    },
    selectedPackage: {
      handler(newVal) {
        if (newVal) {
          console.log(newVal);
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.GetPackage();
    this.choosenCourse();
  },
};
</script>
<style lang="scss" scoped>
.btn.btn-danger {
  margin-left: -22px;
  color: #ff5756 !important;
  background-color: #ffebef !important;
  border: none !important;
}

::v-deep .partner .multiselect__content-wrapper {
  width: 200% !important;
  position: absolute;
  z-index: 1000;
}
::v-deep .partner .multiselect__content {
  width: 100px;
}

::v-deep .partner .multiselect__element {
  width: fit-content;
  white-space: nowrap;
}
</style>
